import { defineStore } from "pinia";
import { useBreakpoints, breakpointsTailwind } from "@vueuse/core";
import type { TLangOption } from "@/components/shared/langSwitcher/LangSwitcher.vue";
import { $t } from "@/i18n";

export const useDefaultStore = defineStore("main", () => {
  const isMobileToggled = ref(false);
  const breakpoints = useBreakpoints({
    ...breakpointsTailwind,
    custom1307: 1307,
  });
  const isMobile = breakpoints.smaller("md");
  const isWiderThan1307 = breakpoints.greater("custom1307");
  const langSelected = ref<TLangOption | null>(null);
  const heroSectionKey = ref(1);

  const SITE_NAME = import.meta.env.VITE_APP_APP_NAME as string;

  const isMobileView = computed(() => isMobile.value && isMobileToggled.value);

  watch(isMobile, (val) => {
    if (!val) {
      isMobileToggled.value = false;
    }
  });

  const services = computed(() => [
    { name: "ElectricalInstallationsPage", label: $t("app.nav.services.list.electricalInstallations") },
    { name: "HeatPumpsPage", label: $t("app.nav.services.list.heatPumps") },
    { name: "SolarPanelsPage", label: $t("app.nav.services.list.solarPanels") },
    { name: "VideoSurveillancePage", label: $t("app.nav.services.list.videoSurveillance") },
    { name: "AirConditioning", label: $t("app.nav.services.list.airConditioning") },
  ]);

  return {
    isMobileView,
    isMobileToggled,
    isMobile,
    langSelected,
    services,
    isWiderThan1307,
    heroSectionKey,
    SITE_NAME,
  };
});
